<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>{{this.editUserForm.controls.name.value}}</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <nav ngbNav #nav="ngbNav" class="grey-tab">
        <ng-container [ngbNavItem]="0">
          <a ngbNavLink translate>
            <span translate>lblUserInformation</span>
          </a>
          <ng-template ngbNavContent>
            <form [formGroup]="editUserForm" *ngIf="editUserForm" (ngSubmit)="onSubmit()">
              <div class="card-accord scrollbar longtab">
                <div class="card p-0">
                  <div class="cst-acc-card mb20">
                    <div class="row">
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="role"><span translate>lblRole</span><span class="text-danger"> * </span>
                        </label>
                        <div class="lbl-info">
                          <select formControlName="roleId"
                            [ngClass]="{'is-invalid': (cpf.roleId.touched || cpf.roleId.dirty) && cpf.roleId.errors}"
                            class="custom-select custom-select mb-2"
                            (change)="onRoleSelected($event)">
                            <option *ngFor="let role of roleList" [ngValue]="role.id">
                              {{role.roleName}}</option>
                          </select>
                          <div *ngIf="(cpf.roleId.touched || cpf.roleId.dirty) && cpf.roleId.errors">
                            <div *ngIf="cpf.roleId.errors.required || cpf.roleId.errors.min || cpf.roleId===-1"
                              class="help-block mt-1 text-danger" translate>
                              lblRoleRequired
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="dealer" translate>lblDealer <span class="text-danger">*</span></label>
                        <ng-container *ngIf="receptionRole; else else_block">
                          <div class="lbl-info"  >
                            <select formControlName="dealerId"
                              [ngClass]="{'is-invalid': (cpf.dealerId.touched || cpf.dealerId.dirty) && cpf.dealerId.errors}"
                              class="custom-select mb-2" >
                              <option *ngFor="let dealer of dealerListSingleSelection" [ngValue]="dealer.value">
                                {{dealer.text}}</option>
                            </select>
                            <div *ngIf="(cpf.dealerId.touched || cpf.dealerId.dirty) && cpf.dealerId.errors">
                              <div *ngIf="cpf.dealerId.errors.required || cpf.dealerId.errors.min || cpf.dealerId==-1"
                                class="help-block mt-1 text-danger" translate>
                                lblDealerRequired
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #else_block>
                          <div>
                            <ng-multiselect-dropdown  [settings]="dropdownSettings" [data]="dealerList" [(ngModel)]="selectedItems" placeholder="{{ 'lblSelectDealer'| translate}}" 
                            (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)"
                            formControlName="dealerIds">
                            </ng-multiselect-dropdown>
                          </div>
                        </ng-template>
                      </div>
                      
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="defaultDealer" translate>lblDefaultDealer <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <ng-select formControlName="defaultDealerId"
                                     [items]="defaultDealerOptions"
                                     bindLabel="text"
                                     bindValue="value"
                                     [clearable]="false"
                                     placeholder="{{ 'lblSelectDealer' | translate }}">
                          </ng-select>
                          <div *ngIf="(cpf.defaultDealerId.touched || cpf.defaultDealerId.dirty) && cpf.defaultDealerId.errors">
                            <div *ngIf="cpf.defaultDealerId.errors.required" class="help-block mt-1 text-danger" translate>
                              lblDefaultDealerRequired
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="name" translate>lblName <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" maxlength="30"
                            [ngClass]="{'is-invalid': (cpf.name.touched || cpf.name.dirty) && cpf.name.errors}"
                            placeholder="{{ 'lblEnterName' | translate }}">
                          <div *ngIf="(cpf.name.touched || cpf.name.dirty) && cpf.name.errors">
                            <div *ngIf="cpf.name.errors.required" class="help-block mt-1 text-danger" translate>
                              lblNameRequired
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div class="col-md-6 col-lg-6 col-xl-3 af-form-group">
                        <label for="mobile" translate>lblMobile <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobile" [cssClass]="{'form-control': true, 'is-invalid': (cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors}"
                          [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false"
                          [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                          [customPlaceholder]="'lblEnterMobile' | translate" (keyup)="onMobileNoChange()"
                          (countryChange)="onCountryChange($event)"
                          ></ngx-intl-tel-input>
                          <div *ngIf="(cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors">
                            <div *ngIf="cpf.mobile.errors.required" class="help-block mt-1 text-danger" translate>
                              lblMobileRequired
                            </div>
                            <div *ngIf="cpf.mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                              lblEnterValidMobile
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div class="col-md-6 col-lg-6 col-xl-3 form-group">
                        <label for="landline" translate>lblLandline</label>
                        <div class="lbl-info">
                          <input formControlName="landline" maxlength="15" (keypress)="isDigit($event)"
                            [ngClass]="{'is-invalid': (cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors}"
                            class="form-control mb-2" placeholder="{{ 'lblEnterLandline' | translate }}">
                          <div *ngIf="(cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors">
                            <div *ngIf="cpf.landline.errors.pattern" class="help-block mt-1 text-danger" translate>
                              lblEnterValidLandline
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div class="col-md-6 col-lg-6 col-xl-3 form-group">
                        <label for="adEmail" translate>lblADEmail <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="adEmail" maxlength="50"
                            [ngClass]="{'is-invalid': (cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors}"
                            class="form-control mb-2" placeholder="{{ 'lblEnterEmail' | translate }}">
                          <div *ngIf="(cpf.adEmail.touched || cpf.adEmail.dirty) && cpf.adEmail.errors">
                            <div *ngIf="cpf.adEmail.errors.required" class="help-block mt-1 text-danger" translate>
                              lblADEmailRequired
                            </div>
                            <div *ngIf="cpf.adEmail.errors.pattern" class="help-block mt-1 text-danger" translate>
                              lblEnterValidADEmail
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div class="col-md-6 col-lg-6 col-xl-3 form-group">
                        <label for="ADUSerId" translate>lblADGUID <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                          <input formControlName="adUserId" id="ADUSerId" class="form-control mb-2"
                            [ngClass]="{'is-invalid': (cpf.adUserId.touched || cpf.adUserId.dirty) && cpf.adUserId.errors}"
                            placeholder="{{ 'lblEnterADGUID' | translate }}" maxlength="36">
                          <div *ngIf="(cpf.adUserId.touched || cpf.adUserId.dirty) && cpf.adUserId.errors">
                            <div *ngIf="cpf.adUserId.errors.required" class="help-block mt-1 text-danger" translate>
                              lblADGUIDRequire
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div class="col-md-6 col-lg-6 col-xl-3 form-group">
                        <label>&nbsp;</label>
                        <div class='lbl-info'>
                          <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                            <label class="custom-control-label" for="isActive" translate>lblActive</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-3 bg-light pp-footer-top-brdr">
              <div class="row">
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                  <button class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="editUserForm.invalid"
                    translate>lblUpdate</button>
                  <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                </div>
              </div>
            </div>
            </form>
          </ng-template>
        </ng-container>

        <ng-container [ngbNavItem]="1">
          <a ngbNavLink translate>
            <span translate>lblUserShiftDetails</span>
          </a>
          <ng-template ngbNavContent>
           <app-edit-user-shift [userId]="this.receptionBusinessService.userId"></app-edit-user-shift>
          </ng-template>
        </ng-container>

        <ng-container [ngbNavItem]="2">
          <a ngbNavLink translate>
            <span translate>lblUserLeave</span>
          </a>
          <ng-template ngbNavContent>
           <app-user-leave [userId]="this.receptionBusinessService.userId"></app-user-leave>
          </ng-template>
        </ng-container>
      </nav>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>
</div>
